import ServiceBase from "@affinity/Store/ServiceBase"
import { QuantityViewModel } from "@affinity/Store/StoreTypes";
import logger from "@insite/client-framework/Logger";
import { post } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

class ServiceEmail extends ServiceBase {
    async postTellAFriendUrl(email: string, productId: string, productDescription: string, messageDetails: string) {    
        const result = await post(`${this.tellAFriendUrl}`, {
            uri : "",
            friendsName: "",
            friendsEmailAddress: email,
            yourName: "",
            yourEmailAddress: "",
            yourMessage: messageDetails,
            "productId": productId,
            productImage: "",
            productShortDescription: productDescription
        });

        return result;
    }
}

export default ServiceEmail;